import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { TerraStatusBadgeModule } from '@ninety/terra';

import { DiscussionListItem, DiscussionModel } from '../../models/discussion.models';
import { DiscussionStatusPipe, DiscussionStatusSeverityPipe } from '../../pipes/discussion-status.pipe';
@Component({
  selector: 'nty-discussion-status-badge',
  imports: [DiscussionStatusPipe, DiscussionStatusSeverityPipe, TerraStatusBadgeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <terra-status-badge [color]="discussion | discussionStatusSeverity">{{
      discussion | discussionStatus
    }}</terra-status-badge>
  `,
})
export class DiscussionStatusBadgeComponent {
  @Input({ required: true }) discussion!: DiscussionListItem | DiscussionModel;
}
